import { useTranslation } from "react-i18next";
import "./GlPlanSingle.scss";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import newRequest from '../../../utils/newRequest';
import { GridLoader, ScaleLoader } from "react-spinners";
import { motion } from "framer-motion";
import numeral from "numeral";
import { MdClose, MdEdit, MdOutlineNumbers, MdSave } from 'react-icons/md';
import { IoArrowForwardSharp, IoClose, IoDocumentTextSharp } from 'react-icons/io5';
import CircularButton, { CustomLoadingButton } from "../../../components/ui/CustomButton";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports";
import {
    DialogActions,
    Dialog,
    DialogTitle,
    DialogContent,
    Table,
    TableContainer,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    Typography,
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Paper
} from "@mui/material";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog";
import { IoIosRefresh } from "react-icons/io";
import { qilloIconMap } from "../../../utils/iconMapping";
import { ImHome } from "react-icons/im";
import { SlArrowDown } from "react-icons/sl";
import { FiSearch } from "react-icons/fi";
import { showToast } from "../../../toastService";
import { BsCalendar3 } from "react-icons/bs";
import { GrStatusCriticalSmall } from "react-icons/gr";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";

const GlPlanSingle = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const parts = location.pathname.split("/");
    const [isProcessing, setIsProcessing] = useState(false);
    const { currentUser } = useSelector((state) => state.user);
    const { currentTheme } = useSelector((state) => state.theme);
    const [isLoading, setIsLoading] = useState(false);
    const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
    const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
    const [notifyDialogText, setNotifyDialogText] = useState("Text");

    const [passedDocId, setPassedDocId] = useState(parts[parts.length - 1]);
    const [planData, setPlanData] = useState(null);
    const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
    const [confirmDialogAction, setConfirmDialogAction] = useState("None");
    const [confirmationActiontext, setConfirmationActiontext] = useState("");
    const [documentEnabled, setDocumentEnabled] = useState("Y");
    const [saveEnabled, setSaveEnabled] = useState("Y");
    const [nextAction, setNextAction] = useState("Validate");
    const [metricsDialogOpen, setMetricsDialogOpen] = useState(false);
    const [reportGroupArray, setReportKeysArray] = useState(["ri-batcheses"]);
    // reports
    const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
    const [selectedPeriod, setSelectedPeriod] = useState(null);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryMetrics, setSelectedCategoryMetrics] = useState([]);
    const [updateFilters, setUpdateFilters] = useState(null);
    const [selectedItem, setSelectedItem] = useState(null);
    const [itemMetrics, setItemMetrics] = useState([]);
    const [selectedItemMetric, setSelectedItemMetric] = useState(null);
    const [itemsData, setItemsData] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [searchTermItems, setSearchTermItems] = useState("");
    const [itemsPage, setItemsPage] = useState(0);
    const [rowsPerPageItems, setRowsPerPageItems] = useState(8);
    const filteredItemsData = itemsData.filter(
        (item) =>
            item.item_code?.toLowerCase().includes(searchTermItems?.toLowerCase()) ||
            item.item_name?.toLowerCase().includes(searchTermItems?.toLowerCase())
    );

    const slicedItemsData = filteredItemsData.slice(
        itemsPage * rowsPerPageItems,
        itemsPage * rowsPerPageItems + rowsPerPageItems
    );

    const handleItemsChangePage = (event, newPage) => {
        setItemsPage(newPage);
    };

    const handleItemsChangeRowsPerPage = (event) => {
        setRowsPerPageItems(parseInt(event.target.value, 8));
        setItemsPage(0);
    };

    const handleAccodionChange = (panel, item) => (event, isExpanded) => {
        try {
            setExpanded(isExpanded ? panel : false);
            setSelectedItem(isExpanded ? item : null);
            setItemMetrics(item?.item_metrics);
            setSelectedPeriod(null);
        } catch (error) {
            console.log(error)
        }
    };


    const handleConfirm = async () => {
        try {
            if (confirmDialogAction === "closeClaim") {
            }
        } catch (err) {
            console.log(err);
        }
        // Close the dialog
        setIsConfirmDialogOpen(false);
    };


    const saveRecord = async (e) => {
        try {

        } catch (err) {
            console.log(err);
        }
    };

    const fetchPlan = async (doc_id, firstTime = false) => {
        try {
            if (firstTime) {
                setIsLoading(true);
            }
            const res = await newRequest.get(`/planning/find/${doc_id}`);

            if (res.data) {
                setPlanData(res.data);
                setSelectedCategory(res.data?.plan_applicable_categories[0]);
                setSelectedCategoryMetrics(res.data?.plan_applicable_categories[0]?.category_metrics);
                const items = res.data?.plan_items?.filter(
                    (obj) => obj.item_type === res.data?.plan_applicable_categories[0]?.category_type &&
                        obj.item_filter === res.data?.plan_applicable_categories[0]?.category_filter
                );
                setItemsData(items);
                setItemsPage(0);
            }
        } catch (err) {
            console.log(err);
        } finally {
            if (firstTime) {
                setIsLoading(false);
            }
        }
    };


    const handleMetricChange = (e, metricType) => {
        const value = parseFloat(e.target.value); // or Number(e.target.value)
        setSelectedCategoryMetrics(prev =>
            prev.map(metric =>
                metric.metric_type === metricType
                    ? { ...metric, metric_value: value }
                    : metric
            )
        );
    };

    useEffect(() => {
        if (passedDocId === "new" || passedDocId === undefined) {
            setDocumentEnabled("Y");
        } else {
            fetchPlan(passedDocId, true);
        }
    }, [passedDocId]);


    const handleSearchItems = async () => {
        try {
            setIsLoading(true);
            if (searchTermItems) {
                const res = await newRequest.post("/planning/search", {
                    search_input: searchTermItems
                });
                setItemsData(res.data);
            } else {
                fetchPlan(passedDocId, true);
            }
        } catch (error) {
            console.error("Error searching data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <motion.div
            className="gl-plan"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1, transition: { duration: 1 } }}
            exit={{ opacity: 0, transition: { duration: 1 } }}
        >
            {isLoading ? (
                <div className="no-content">
                    <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
                </div>
            ) : (
                <div className="gl-plan-main-wrapper">
                    <div className="navbar">
                        <div className="navbar-left">
                            <h1 className="main-title"> {planData?.plan_name}</h1>
                        </div>
                        <div className="navbar-right">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#0f766e5d"
                                endIcon={<IoIosRefresh />}
                                onClick={async () => await fetchPlan(passedDocId)}
                            >
                                {t('refresh')}
                            </CustomLoadingButton>
                            {nextAction !== "None" &&
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#fbbf24"
                                    endIcon={<IoArrowForwardSharp />}
                                    onClick={() => { }}
                                >
                                    {nextAction}
                                </CustomLoadingButton>}
                            {saveEnabled === "Y" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#00D37F"
                                    tooltip="Save changes"
                                    endIcon={<MdSave />}
                                    onClick={saveRecord}>
                                    {t('save')}
                                </CustomLoadingButton>
                            )}
                            {passedDocId !== "new" && (
                                <CustomLoadingButton
                                    currentTheme={currentTheme}
                                    iconPosition="end"
                                    borderRadiusType="both"
                                    variant="tint"
                                    color="#2563EB"
                                    tooltip="Run reports for this document"
                                    endIcon={<IoDocumentTextSharp />}
                                    onClick={() => setReportsDialogOpen(true)}>
                                    {t('reports')}
                                </CustomLoadingButton>
                            )}
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                borderRadiusType="both"
                                variant="tint"
                                color="#f55656"
                                tooltip="Close this form"
                                endIcon={<MdClose />}
                                onClick={() => navigate(-1)}>
                                {t('close')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                    <div className="content-summary-wrapper">
                        <div className="content-wrapper">
                            {/* <div className="form-wrapper">
                                <div className="form-row">
                                    <div className="form-left">
                                        <div className="input-item-with-label" style={{ width: "100%" }}>
                                            <label htmlFor="plan_name" style={{ width: "100px" }}>
                                                {t('name').toUpperCase()}
                                            </label>
                                            <input
                                                id="plan_name"
                                                name="plan_name"
                                                type="text"
                                                placeholder={t('name').toUpperCase()}
                                                value={planData?.plan_name}
                                                className="form-input-item"
                                                style={{ width: "100%" }}
                                                onChange={(e) => {
                                                    try {
                                                        handleSetPlanData("plan_name", e.target.value);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                disabled={planData?.document_enabled_xx === "N"}
                                            />
                                        </div>
                                        <div className="form-row">
                                            <div className="form-left">
                                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                                    <label htmlFor="plan_code" style={{ width: "110px" }}>
                                                        {t('code').toUpperCase()}
                                                    </label>
                                                    <input
                                                        id="plan_code"
                                                        name="plan_code"
                                                        type="text"
                                                        placeholder={t('code').toUpperCase()}
                                                        value={planData?.plan_code}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetPlanData("plan_code", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={planData?.document_enabled_xx === "N"}
                                                    />
                                                </div>
                                            </div>
                                            <div className="form-right">
                                                <div className="input-item-with-label" style={{ width: "100%" }}>
                                                    <label htmlFor="plan_financial_year" style={{ width: "100px" }}>
                                                        {t('year').toUpperCase()}
                                                    </label>
                                                    <input
                                                        id="plan_financial_year"
                                                        name="plan_financial_year"
                                                        type="text"
                                                        placeholder={t('year').toUpperCase()}
                                                        value={planData?.plan_financial_year}
                                                        className="form-input-item"
                                                        style={{ width: "100%" }}
                                                        onChange={(e) => {
                                                            try {
                                                                handleSetPlanData("plan_financial_year", e.target.value);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                        disabled={planData?.document_enabled_xx === "N"}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-right">
                                        <div className="input-item-with-label" style={{ width: "100%" }}>
                                            <label htmlFor="plan_status" style={{ width: "100px" }}>
                                                {t('status').toUpperCase()}
                                            </label>
                                            <input
                                                id="plan_status"
                                                name="plan_status"
                                                type="text"
                                                placeholder={t('status').toUpperCase()}
                                                value={planData?.plan_status}
                                                className="form-input-item"
                                                style={{ width: "100%" }}
                                                onChange={(e) => {
                                                    try {
                                                        handleSetPlanData("plan_status", e.target.value);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}
                                                disabled={planData?.document_enabled_xx === "N"}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> */}

                            <div style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                justifyContent: "space-between",
                                width: "100%"
                            }}>
                                <span className="main-title">{selectedCategory?.category_type}</span>
                                <div className="search-input-wrapper" style={{ width: "50%" }}>
                                    <FiSearch className="search-input-icon" />
                                    <input
                                        className="search-input"
                                        type="text"
                                        placeholder={`${t('search')} ${selectedCategory?.category_type.toLowerCase()} [${selectedCategory?.category_filter.toLowerCase()}]`}
                                        value={searchTermItems}
                                        onChange={(e) => setSearchTermItems(e.target.value)}
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') handleSearchItems();
                                        }}
                                    />
                                    {searchTermItems.length > 0 && (
                                        <MdClose
                                            onClick={async (e) => setSearchTermItems("")}
                                            className="search-input-icon"
                                        />
                                    )}
                                    {searchTermItems.length === 0 && (
                                        <span className="search-input-icon" />
                                    )}
                                </div>
                            </div>
                            {planData?.plan_applicable_categories?.length > 1 &&
                                <div className="categories-wrapper">
                                    {planData?.plan_applicable_categories?.map((catg) => {
                                        const IconComponent = qilloIconMap[catg?.category_icon] || ImHome;
                                        return (
                                            <div key={catg?._id}
                                                className={`${selectedCategory?._id === catg?._id ? "sub-menu-item current" : "sub-menu-item"}`}
                                                onClick={() => {
                                                    try {
                                                        setIsProcessing(true);
                                                        setSelectedCategory(catg);

                                                        setSelectedCategoryMetrics(catg?.category_metrics);
                                                        setSearchTermItems("");
                                                        const items = planData?.plan_items?.filter(
                                                            (obj) => obj.item_type === catg?.category_type &&
                                                                obj.item_filter === catg?.category_filter
                                                        );
                                                        setItemsData(items);
                                                        setIsProcessing(false);
                                                        setItemsPage(0);
                                                    } catch (error) {
                                                        console.log(error);
                                                    }
                                                }}>
                                                <IconComponent className="sub-menu-icon" />
                                                <div className="sub-menu-content">
                                                    <div className="sub-menu-name">{catg?.category_type}</div>
                                                    <div className="sub-menu-description">{catg?.category_filter}</div>
                                                </div>
                                                <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                                    <CircularButton
                                                        currentTheme={currentTheme}
                                                        onClick={(e) => {
                                                            try {
                                                                e.stopPropagation();
                                                                setIsProcessing(true);
                                                                setSelectedCategory(catg);
                                                                setSelectedCategoryMetrics(catg?.category_metrics);
                                                                setSearchTermItems("");
                                                                const items = planData?.plan_items?.filter(
                                                                    (obj) => obj.item_type === catg?.category_type &&
                                                                        obj.item_filter === catg?.category_filter
                                                                );
                                                                setItemsData(items);
                                                                setIsProcessing(false);
                                                                setItemsPage(0);
                                                                setUpdateFilters({
                                                                    item_type: catg?.category_type,
                                                                    item_filter: catg?.category_filter
                                                                });
                                                                console.log(`catg?.category_metrics  ${JSON.stringify(catg?.category_metrics, null, 2)}`);
                                                                setMetricsDialogOpen(true);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }} icon={<MdEdit />} width={"35px"} height={"35px"} />
                                                </div>
                                            </div>)
                                    })}
                                </div>}
                            {/* <hr className="separator-h" /> */}
                            {slicedItemsData?.length > 0 &&
                                <div className="items-table-content">
                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                                        className="table-container">
                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                            <TableBody className="tablebody-accordion">
                                                {slicedItemsData?.map((item, index) => (
                                                    <TableRow
                                                        key={item?.item_docid}
                                                        className="tablerow-accordion">
                                                        <TableCell className="table-cell-accordion"
                                                            style={{
                                                                display: "flex",
                                                                width: "100%",
                                                                alignItems: "center",
                                                                justifyContent: "center",
                                                            }}>
                                                            <Accordion className="accordion" expanded={expanded === item?.item_docid} onChange={handleAccodionChange(item?.item_docid, item)}>
                                                                <AccordionSummary
                                                                    className="accordion-summary"
                                                                    expandIcon={<SlArrowDown className="content-accordion-expand-icon" style={{ color: "#f44336", fontWeight: "bold" }} />}
                                                                    id={`panel-${item?.item_docid}-header`}
                                                                >
                                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", marginRight: "50px" }}>
                                                                        <Typography>
                                                                            <h1 className="sub-title">{itemsPage * rowsPerPageItems + index + 1}. {item.item_name}</h1>
                                                                        </Typography>
                                                                        <Typography>
                                                                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", gap: "10px" }}>
                                                                                <CircularButton
                                                                                    currentTheme={currentTheme}
                                                                                    onClick={(e) => {
                                                                                        try {
                                                                                            e.stopPropagation();
                                                                                            setUpdateFilters({
                                                                                                item_type: selectedCategory?.category_type,
                                                                                                item_filter: selectedCategory?.category_filter,
                                                                                                item_code: item.item_code,
                                                                                            });
                                                                                            setMetricsDialogOpen(true);
                                                                                        } catch (error) {
                                                                                            console.log(error);
                                                                                        }
                                                                                    }} icon={<MdEdit />} width={"35px"} height={"35px"} />
                                                                                <div className="ngen-details">
                                                                                    <h1 className="account-no">{`CODE: ${item.item_code}`}</h1>
                                                                                </div>
                                                                            </div>
                                                                        </Typography>
                                                                    </div>
                                                                </AccordionSummary>
                                                                <AccordionDetails className="accordion-details">
                                                                    <div className="months-grid">
                                                                        {item?.periods?.map((month) => {
                                                                            // Determine the correct class based on multiple conditions
                                                                            let cardClass = 'normal'; // Default class

                                                                            // if (month.beginning_value === 0 && month.ending_death_benefit === 0) {
                                                                            //     cardClass = 'zero';
                                                                            // } else if (month.beginning_value === death_benefit) {
                                                                            //     cardClass = 'opening';
                                                                            // } else if (month.ending_death_benefit === 0 && month.beginning_value > 0) {
                                                                            //     cardClass = 'closing';
                                                                            // }

                                                                            return (
                                                                                <div
                                                                                    key={month?.item_financial_period}
                                                                                    className={`month-card ${cardClass} ${month?.item_financial_period === selectedPeriod?.item_financial_period ? 'active' : ''}`}
                                                                                    onClick={() => {
                                                                                        setSelectedPeriod(month);
                                                                                    }}
                                                                                >
                                                                                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "100%", gap: "10px" }}>
                                                                                        <h4 className="sub-title">{month?.item_financial_period}</h4>
                                                                                        <CircularButton
                                                                                            currentTheme={currentTheme}
                                                                                            onClick={(e) => {
                                                                                                try {
                                                                                                    e.stopPropagation();
                                                                                                    setUpdateFilters({
                                                                                                        item_type: selectedCategory?.category_type,
                                                                                                        item_filter: selectedCategory?.category_filter,
                                                                                                        item_code: item.item_code,
                                                                                                        item_financial_period: month?.item_financial_period
                                                                                                    });
                                                                                                    setMetricsDialogOpen(true);
                                                                                                } catch (error) {
                                                                                                    console.log(error);
                                                                                                }
                                                                                            }} icon={<MdEdit />} width={"35px"} height={"35px"} />
                                                                                    </div>
                                                                                    {month?.item_metrics?.map((metric) => (
                                                                                        <div key={metric?._id} style={{ display: "flex", flexDirection: 'row', alignItems: "center", justifyContent: "space-between" }}>
                                                                                            <span>{metric?.metric_desc}</span>
                                                                                            <p>{numeral(metric.metric_value || 0).format("0,0.00")}</p>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                </AccordionDetails>
                                                            </Accordion>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                        <TablePagination
                                            rowsPerPageOptions={[8]}
                                            rowsPerPage={rowsPerPageItems}
                                            onRowsPerPageChange={handleItemsChangeRowsPerPage}
                                            component="div"
                                            count={filteredItemsData.length}
                                            page={itemsPage}
                                            onPageChange={handleItemsChangePage}
                                        />
                                    </TableContainer>
                                </div>}
                            <span style={{ display: "flex", height: "30px" }} />
                        </div>
                        <div className="summary-wrapper">
                            <div className="summary-content">
                                <h1 className="main-title">{planData?.plan_name}</h1>
                                <hr className="separator-h" />
                                <span className="item-row-details">
                                    <MdOutlineNumbers className="icon" /> <h1 className="sub-title">{planData?.plan_code}</h1>
                                </span>
                                <span className="item-row-details">
                                    <BsCalendar3 className="icon" /> <h1 className="sub-title">{planData?.plan_financial_year || "Unspecified"}</h1>
                                </span>
                                <span className="item-row-details">
                                    <GrStatusCriticalSmall className="icon" /> <h1 className="sub-title">{planData?.plan_status || "Unspecified"}</h1>
                                </span>
                            </div>
                            <hr className="separator-h" />
                            <div className="metrics-summary-wrapper">
                                <span className="sub-title">{`${t('metrics').toUpperCase()} ${t('summary').toUpperCase()}`}</span>
                                {selectedCategoryMetrics?.map((row) => (
                                    <div key={row?._id} style={{ display: "flex", flexDirection: 'row', margin: "10px", alignItems: "center", justifyContent: "space-between" }}>
                                        <span className="sub-title xrsmall">{row?.metric_desc}</span>
                                        <p span className="sub-title xrsmall">{numeral(row?.total_value || 0).format("0,0.00")}</p>
                                    </div>
                                ))}
                                <hr className="separator-h" />
                            </div>
                            <WorkedOnBy name={planData?.updated_by_name_xx} photoUrl={planData?.updated_by_photo_url_xx} time_ago_xx={planData?.time_ago_xx} />
                        </div>
                    </div>
                </div>
            )}
            {/* Dialog to notify user about changes being saved */}
            <Dialog open={isNotifyDialogOpen}
                onClose={() => setIsNotifyDialogOpen(false)}
                PaperProps={{
                    sx: {
                        backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
                        color: currentTheme === "dark" ? "#fff" : "#000",
                    },
                }}
                slotProps={{
                    backdrop: {
                        sx: {
                            backgroundColor: "rgba(0, 0, 0, 0.7)",
                        },
                    },
                }}>
                <DialogTitle>{notifyDialogTitle}</DialogTitle>
                <DialogContent>
                    <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
                </DialogContent>
                <DialogActions>
                    <CustomLoadingButton currentTheme={currentTheme} onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
                </DialogActions>
            </Dialog>
            {/* Confirm Dialog */}
            <ConfirmDialog
                isOpen={isConfirmDialogOpen}
                onClose={() => setIsConfirmDialogOpen(false)}
                onConfirm={handleConfirm}
                dialogTitle="Confirmation"
                dialogContent={<p dangerouslySetInnerHTML={{ __html: confirmationActiontext }} />}
            />
            {reportsDialogOpen && (
                <motion.div
                    className="overlay-dialog reports"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper">
                        <div className="overlay-navbar">
                            <h1 className="main-title">{t('reports')}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <OnScreenReports
                                reportGroupArray={planData?.report_keys_array}
                                documentData={{
                                    docNo: planData?.plan_code,
                                    docType: "Forecast",
                                    docId: passedDocId,
                                    clientEmail: "",
                                    clientEntCode: "",
                                    clientEntName: ""
                                }} />
                        </div>
                    </div>
                </motion.div>
            )}
            {metricsDialogOpen && (
                <motion.div
                    className="overlay-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="overlay-wrapper" style={{ width: "700px" }}>
                        <div className="overlay-navbar">
                            <h1 className="main-title">{`Edit ${selectedCategory?.category_filter?.toLowerCase()} ${selectedCategory?.category_type?.toLowerCase()} ${t('metrics')}`}</h1>
                            <CircularButton currentTheme={currentTheme} onClick={() => setMetricsDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
                        </div>
                        <div className="overlay-content">
                            <div className="content-wrapper">
                                <div className="table-content">
                                    <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                        <Table sx={{ width: "max-content", border: 'none' }}>
                                            <TableHead className="tablehead">
                                                <TableRow className="tablerow">
                                                    <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                        #
                                                    </TableCell>
                                                    <TableCell className="table-cell left" style={{ maxWidth: "450px" }}>
                                                        <span>{t('metric').toUpperCase()}</span>
                                                    </TableCell>
                                                    <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                        <span>{t('value').toUpperCase()}</span>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody className="tablebody">
                                                {selectedCategoryMetrics?.map((row, index) => (
                                                    <TableRow
                                                        key={row._id}
                                                        className={`${selectedItemMetric?.metric_type === row?.metric_type ? "tablerow current" : "tablerow"}`}
                                                        onClick={() => {
                                                            try {
                                                                setSelectedItemMetric(row);
                                                            } catch (error) {
                                                                console.log(error);
                                                            }
                                                        }}
                                                    >
                                                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                                                            {index + 1}
                                                        </TableCell>
                                                        <TableCell className="table-cell left" style={{ maxWidth: "450px" }}>
                                                            <span className="sub-title">{row?.metric_type}</span>
                                                        </TableCell>
                                                        <TableCell className="table-cell right" style={{ maxWidth: "150px" }}>
                                                            <div className="input-item-with-label">
                                                                <input
                                                                    id="metric_value"
                                                                    name="metric_value"
                                                                    type="number"
                                                                    value={row?.metric_value}
                                                                    onChange={(e) => handleMetricChange(e, row.metric_type)}
                                                                    style={{ width: "100%", textAlign: "right" }}
                                                                    className="form-input-item table"
                                                                />
                                                            </div>
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        </div>
                        <div className="overlay-actions">
                            <CustomLoadingButton
                                currentTheme={currentTheme}
                                iconPosition="end"
                                onClick={async () => {
                                    try {
                                        const res = await newRequest.post("/planning/updatePlanMetrics", {
                                            plan_docid: passedDocId,
                                            filters: updateFilters,
                                            new_metrics: selectedCategoryMetrics
                                        });
                                        if (res.data?.msg === "updated") {
                                            setUpdateFilters(null);
                                            await fetchPlan(passedDocId);
                                            setMetricsDialogOpen(false);
                                            showToast("Updated!", "success");
                                        } else {
                                            showToast("Error updating report!", "error");
                                        }
                                    } catch (error) {
                                        console.log(error);
                                    }
                                }}>
                                {t('update')}
                            </CustomLoadingButton>
                        </div>
                    </div>
                </motion.div>
            )}
            {isProcessing && (
                <motion.div
                    className="processing-dialog"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                >
                    <div className="processing-wrapper">
                        <GridLoader
                            color="#F44336"
                            style={{
                                height: "50px",
                                width: "50px",
                            }}
                        />
                    </div>
                </motion.div>
            )}
        </motion.div >
    )
};

export default GlPlanSingle;